package ar.corzo.health_tracker.utils

import ar.corzo.health_tracker.types.Raw
import kotlinx.datetime.Instant
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.booleanOrNull
import kotlinx.serialization.json.buildJsonArray
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.doubleOrNull
import kotlinx.serialization.json.floatOrNull
import kotlinx.serialization.json.intOrNull
import kotlinx.serialization.json.jsonArray
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive

fun JsonElement.asStringOrNull() = jsonPrimitive.contentOrNull
fun JsonObject.getStringOrNull(key: String) = get(key)?.asStringOrNull()

fun String.toJsonObject() = try{Json.parseToJsonElement(this).jsonObject}catch(_:Throwable){null}
fun String.toJsonArray() = try{Json.parseToJsonElement(this).jsonArray}catch(_:Throwable){null}

fun <T> List<T>.toJson( transform: (T)-> JsonElement? = {it.parseNativeToJson()}): JsonArray {
	return buildJsonArray{
		forEach{ item ->
			(transform(item)?: JsonNull).let(::add)
		}
	}
}
fun <V> Map<String, V>.toJson( transform: (V)-> JsonElement = {it.parseNativeToJson()}): JsonObject {
	return buildJsonObject{
		forEach{ (k,v) ->
			if(v==null)
				put(k,JsonNull)
			else{
				val value = transform(v)
				put(k, value)
			}
		}
	}
}

// from kotlin value to json
fun Any?.parseNativeToJson(): JsonElement {
	return when(this){
		is Raw<*>-> raw.parseNativeToJson()
		is Instant -> toEpochMilliseconds().parseNativeToJson()
		is Iterable<*> -> toList().toJson()
		is Map<*, Any?> -> asMap<Any>()?.toJson() ?: JsonNull
		is String -> JsonPrimitive(this)
		is Number -> JsonPrimitive(this)
		is Boolean -> JsonPrimitive(this)
		is JsonElement -> this
		else -> JsonNull
	}
}
// from json to kotlin value
fun JsonObject.parseJsonToNative() = map{(k,v)-> k to v.parseJsonToNative()}.toMap()
fun JsonArray.parseJsonToNative() = map{it.parseJsonToNative()}
fun JsonElement.parseJsonToNative():Any?{
	return when(this){
		is JsonNull -> null
		is JsonArray -> parseJsonToNative()
		is JsonObject -> parseJsonToNative()
		is JsonPrimitive -> if(isString) contentOrNull else booleanOrNull ?: intOrNull ?: doubleOrNull ?: floatOrNull
	}
}
